<template>
  <base-dialog class="setting-template-dialog" :visible.sync="visible">
    <template v-slot:header>模板设置</template>
    <div>
      <el-form class="form" :model="form" label-position="left" label-width="92px">
        <el-form-item label="模板名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="模板图标" class="design-icon">
          <span
            class="icon-info"
            :style="form.color ? 'background:' + form.color : 'background:' + appColors[0]"
          >
            <svg-icon
              style="color: #fff"
              :icon-class="form.icon ? 'app_' + form.icon : 'app_' + appIcons[0]"
            ></svg-icon>
          </span>
          <design-icon-popper
            style="margin: 4px 8px"
            :colors="appColors"
            :icons="appIcons"
            :cur-data="form"
            from="app"
            @changeData="changeAppInfo"
          ></design-icon-popper>
        </el-form-item>
        <el-form-item label="模板封面" class="design-icon">
          <img
            :src="form.templateInfo.cover || defaultCover"
            alt=""
            style="height: 48px;margin-right: 10px"
          />
          <template-pic-selector v-model="form.templateInfo.cover"></template-pic-selector>
        </el-form-item>
        <el-form-item label="模板介绍">
          <el-input type="textarea" :rows="4" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="模板图片">
          <upload-file
            ref="uploadFile"
            @updateFiles="updateFiles"
            :limited-file-suffix="['jpg', 'jpeg', 'png']"
          ></upload-file>
        </el-form-item>
        <el-form-item label="使用范围">
          <el-radio-group v-model="form.templateInfo.range">
            <el-radio label="SELF">本企业</el-radio>
            <el-radio label="CONNECT">互联企业</el-radio>
            <el-radio label="ALL">全网</el-radio>
          </el-radio-group>
          <el-select
            v-if="form.templateInfo.range == 'CONNECT'"
            v-model="form.templateInfo.openRoleList"
            multiple
            placeholder="请选择"
            style="width:100%"
          >
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板分类" v-if="form.templateInfo.range === 'ALL'">
          <el-select v-model="form.templateInfo.subType" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in templateTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            应用权限
            <el-tooltip
              content="是否允许使用该模板的应用编辑工作表、工作流、互联等模块"
              placement="bottom"
            >
              <div class="el-icon-warning-outline" style="margin-left:5px"></div>
            </el-tooltip>
          </template>
          <el-radio-group v-model="form.templateInfo.priMode">
            <el-radio label="OPEN">开放</el-radio>
            <el-radio label="LIMITED">限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.templateInfo.onlyOne">同一企业只允许安装一次</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">{{ isPublish ? "下一步" : "确定" }}</base-button>
    </template>
    <publish-template-dialog
      ref="publishTemplateDialog"
      @refresh="refresh"
    ></publish-template-dialog>
  </base-dialog>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import { appColors, appIcons, templateTypes } from "@/views/Company/Manage/App/static"
import PublishTemplateDialog from "@/views/Company/Manage/App/TemplateDialogs/PublishTemplateDialog"
import { getCompanyConnectType } from "@/api/connect"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import UploadFile from "@/components/Sheet/SheetForm/FormItem/UploadFile"
import { updateApp } from "@/api/userCenter/app"
import TemplatePicSelector from "@/components/BaseComponents/TemplatePicSelector"
export default {
  name: "setting-template-dialog",
  components: {
    TemplatePicSelector,
    UploadFile,
    BaseDialog,
    DesignIconPopper,
    PublishTemplateDialog,
    BaseButton
  },
  data() {
    return {
      appIcons,
      appColors,
      templateTypes,
      defaultCover: require("@/assets/images/template-default.png"),
      fileList: [],
      visible: false,
      isPublish: false,
      companyList: [],
      form: {
        templateInfo: {
          imgList: []
        }
      }
    }
  },
  created() {
    getCompanyConnectType({ withNum: false, noCache: false }).then(companies => {
      this.companyList = companies.map(company => {
        return { value: company.id, label: company.name }
      })
    })
  },
  methods: {
    open(app, isPublish = false) {
      this.visible = true
      this.isPublish = isPublish
      this.form = app
      this.$nextTick(() => this.$refs.uploadFile.init(app.templateInfo.imgFileList))
    },
    changeAppInfo(key, val) {
      this.$set(this.form, key, val)
    },
    updateFiles(files) {
      this.$set(
        this.form["templateInfo"],
        "imgList",
        files.map(f => f.id)
      )
    },
    submit() {
      updateApp(this.form).then(() => {
        if (this.isPublish) {
          this.$refs.publishTemplateDialog.init(this.form)
        } else {
          this.$message.success("保存成功")
          this.$emit("refresh")
          this.visible = false
        }
      })
    },
    refresh() {
      this.$emit("refresh")
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-template-dialog {
  .app-icon {
    @include flex-center;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    background: rgba(248, 177, 116, 1);
    border-radius: 12px;
    margin-right: 10px;
    font-size: 28px;
    color: #fff;
  }
  .design-icon {
    .icon-info {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      font-size: 30px;
      border-radius: 6px;
    }
    ::v-deep {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  .upload-file {
    position: relative;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    min-height: 32px;
    .upload-container {
      .upload-button {
        position: absolute;
        top: 0;
        left: 5px;
        font-size: $font-size-main;
      }
      &.is-multiple {
        ::v-deep {
          .el-upload {
            min-height: 143px;
            &:focus {
              color: #9e9e9e;
            }
            &:hover {
              .empty-text:not(.is-disabled) {
                color: $color-main;
              }
            }
          }
        }
      }
      ::v-deep {
        .el-upload {
          display: flex;
          flex-direction: column;
        }
        .el-upload-dragger {
          flex: auto;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border: none;
          background-color: transparent;
          overflow: visible;
          position: static;
          .empty-text {
            margin-top: 50px;
            font-size: $font-size-main;
            color: $color-font-third;
          }
        }
      }
    }
  }
}
</style>
